import type { Insurance, Product } from '@features/product/typings';

export function getInsurableProduct(product: Product, insurance: Insurance) {
  return (
    product.subProducts?.find(
      subProduct => subProduct?.product?.id === insurance.insurableProductId
    )?.product ?? product
  );
}
